import { inject } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TaggingService } from '../services/tagging.service';
import { magInOpdracht, TAGGING_KOP } from '../helpers/tagging-opdracht';

/**
 * Op de pagina's van een wedstrijd die de gebruiker voor een taggingteam tagt
 * (de wedstrijd, de videospeler; zie isOpdrachtRoute):
 * de kop `X-Tagging-Assignment` naar de aanroepen die binnen een opdracht
 * mogen (helpers/tagging-opdracht.ts). Al het andere gaat zonder kop, als
 * gewone gebruiker van het eigen team.
 */
export const taggingInterceptorProvider = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  if (!request.url.startsWith(environment.apiUrl)) {
    return next(request);
  }
  const tagging = inject(TaggingService);
  if (!tagging.isTagger() && !tagging.isBeheerder()) {
    return next(request);
  }
  const opdracht = tagging.opdracht(inject(Router).url);
  if (!opdracht || request.headers.has(TAGGING_KOP) || !magInOpdracht(request.method, request.url.slice(environment.apiUrl.length))) {
    return next(request);
  }
  return next(request.clone({ setHeaders: { [TAGGING_KOP]: opdracht } }));
};
